import React from "react";
// import { useSelector } from "react-redux";
import "./CurrentStepIndicator.scss";

const CurrentStepIndicator = ({ StepCount }) => {
    const steps = [
        {
            stepName: "Sign up",
            name: "SignUp",
        },
        {
            stepName: "Your Details",
            name: "companyDetails",
        },
        {
            stepName: "Add Social Profiles",
            name: "socialProfile",
        },
        {
            stepName: "Create Query",
            name: "createQuery",
        },
    ];
    // const stepsCompleted = useSelector((state) => state.globalReducer.stepsCompleted);

    return (
        <>
            <div className="step__indicator">
                {steps.map((stepObj, idx) => {
                    // let isComplete = stepsCompleted.includes(stepObj.name) || stepObj.name === "SignUp";
                    return (
                        <div
                            className={`individual__step ${stepObj.name} ${StepCount === idx + 1 ? "current__step" : ""} ${
                                idx + 1 < StepCount ? "step__completed" : ""
                            }`}
                            key={stepObj.name}>
                            <p> Step {idx + 1}</p>
                            <p> {stepObj.stepName}</p>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default CurrentStepIndicator;
